export const environment = {
  appName: 'Handyhand',
  appUrl: 'https://nl.handyhand.dev',
  country: 'Netherlands',
  platformUrl: 'https://nl.handyhand.dev/platform',
  production: true,
  env: 'development',
  supportEmail: 'support@handyhand.nl',
  supportPhone: '+31 20 1234567',
  apiUrl: 'https://api.handyhand.dev/api',
  apiV2Url: 'https://api-v2.handyhand.dev',
  vectorServiceUrl: 'https://vector.handyhand.nl/api', // There's no vector dev environment, using production
  dashboardBaseRef: 'https://api-dashboard.handyhand.dk/',
  apiPrefix: 'nl/',
  resizeUrl: 'https://d1w6ef92qmwkur.cloudfront.net',
  cloudFrontImgUrl: 'https://d10a6kin4dgxel.cloudfront.net',
  domain: 'https://nl.handyhand.dev',
  googleTagId: 'GTM-',
  social: {
    fb: 'https://nl-nl.facebook.com/handyhand',
    instagram: 'https://www.instagram.com/handyhand.nl/',
    linkedin: 'https://nl.linkedin.com/company/handy-hand',
  },
};
